export default "__VITE_ASSET__e06276da__"